var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, } from 'class-validator';
import { D2CSourceApp } from '../../../enums';
export class CreatePreReservationConfirmD2CPaymentDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "paymentKey", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "amount", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "referralCode", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "isFullCoverage", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "sureUserId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "mileageAmount", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "applyReferralDiscount", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "memo", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "nationality", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "useSuperInsuranceItem", void 0);
__decorate([
    IsEnum(D2CSourceApp),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "sourceApp", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "utmSource", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "utmMedium", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "utmCampaign", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "utmContent", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "utmTerm", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "landingPath", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePreReservationConfirmD2CPaymentDto.prototype, "referrerHost", void 0);
